import React from "react";
import "./comingsoon.scss";
import Comingsoon from "../../../Media/Newlaunch_Desktop.webp";
import Soon from "../../../Media/Newlaunch_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(Iconix%20Infinite)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Maple" className="container-soon">
      <div className="judulnbs">
        <h1>New Launching</h1>
        <h2>Iconix Inifinite</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-lokasi-dekstop" src={Comingsoon} alt="maps" />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
